"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styles = require("./SinglePaymentOption.styles.scss");
const parentStyles = require("./ActivePaymentOption.styles.scss");
const fa_1 = require("react-icons/fa");
const SinglePaymentOption_1 = require("./SinglePaymentOption");
const PaymentIcon_1 = require("./PaymentIcon");
exports.default = ({ icon, description, name, onSelect }) => {
    var _a;
    let brandName = (0, SinglePaymentOption_1.formatBrandName)(name);
    let iconName = (_a = icon) !== null && _a !== void 0 ? _a : "creditCard";
    return (React.createElement("div", { onClick: onSelect, className: `${styles.mainFonts} ${parentStyles.singlePaymentContainer}` },
        React.createElement("div", { className: styles.paymentIconContainer },
            React.createElement(PaymentIcon_1.default, { type: iconName }),
            description && React.createElement("div", { style: { fontSize: 10 } }, description)),
        React.createElement("div", null),
        React.createElement("div", { className: parentStyles.brandName },
            React.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                } },
                React.createElement("span", null, brandName))),
        React.createElement("div", { className: parentStyles.changeArrow },
            React.createElement("div", null, "Change"),
            React.createElement("div", null,
                React.createElement(fa_1.FaChevronRight, null)))));
};
//# sourceMappingURL=ActivePaymentOption.js.map